<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="m8 14.667-4-4 .95-.95L8 12.767l3.05-3.05.95.95-4 4Zm-3.033-8.4L4 5.333l4-4 4 4-.967.934L8 3.233 4.967 6.267Z"
        />
    </svg>
</template>

<script setup lang="ts">
type ExpandAllIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<ExpandAllIconProps>();
</script>
